// extracted by mini-css-extract-plugin
export default {"envelopeWrapper":"envelopeWrapper--S_Fm0","blink":"blink--r7Tri"};